<template>
    <div class="content">
        <div style="padding-top: 20px;"></div>
        <div class="title-class">服务器：{{ server_name }}</div>
        <div class="title-class">客服：{{ qq_contact }}</div>
        <div style="display: none;"></div>
        <div ref="alipayWeb" v-html="alipay"></div>
        <div class="form-class">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="账号" prop="game_account_name">
                    <el-input v-model="ruleForm.game_account_name"></el-input> 
                    <el-button type="success" icon="el-icon-search" class="get-role" @click="getCharList" :loading="queryCharBtn">获取游戏角色</el-button>
                </el-form-item>
                <el-form-item label="角色" prop="game_char_id">
                    <el-select v-model="ruleForm.game_char_id" placeholder="请选择角色">
                        <el-option
                            v-for="item in options"
                            :key="item.game_char_id"
                            :label="item.game_char"
                            :value="item.game_char_id">
                        </el-option>
                    </el-select><span style="font-size: small; color: red;">输入游戏账号后，通过点击《获取游戏角色》加载角色信息</span>
                </el-form-item>
                <el-form-item label="金额" prop="price">
                   <!-- <el-input-number v-model="ruleForm.price" :min="0.01" :max="100000000" :precision="2"></el-input-number>-->
                   <el-input-number v-model="ruleForm.price" :min="1" :max="100000000"></el-input-number>充值比例:<span style="color: red;">{{ pay_scale }}</span>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="ruleForm.remark" type="textarea"  :rows="2"></el-input>
                </el-form-item>
                <el-form-item label="支付方式" prop="pay_way">
                    <el-radio-group v-model="ruleForm.pay_way">
                        
                    <el-radio label="1" style="color: chartreuse;">  <el-image
                      style="width: 70px; height: 30px"
                      :src="alipayLogo"></el-image></el-radio>
                    <el-radio label="2" style="color: chartreuse;"><el-image
                      style="width: 30px; height: 30px"
                      :src="weixinPayLogo"
                      ></el-image>微信</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="submitForm('ruleForm')" :loading="payBtn">立即支付</el-button>
                </el-form-item>
            </el-form>

        </div>

        <el-dialog
          title="支付"
          :visible.sync="wxPayDialogVisible"
          width="30%"
          :before-close="handleClose" center>
          <span style="margin-left: 40%;">
          <el-image   :src="pay_qrcode"></el-image></span>
          <span v-if="tipFlag" style="color: red;">{{ tip }}</span>
          <span v-else style="color: green;">{{ tip }}</span>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="wxPayDialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>

    </div>
</template>
<script>
import alipayLogo from '@/assets/alipay.png'
import weixinPayLogo from '@/assets/weixintubiao.png'
import {Form, Message} from 'element-ui';
  export default {
    data() {
      return {
        wxPayDialogVisible:false,
        weixinPayLogo:weixinPayLogo,
        alipayLogo:alipayLogo,
        ruleForm: {
          game_account_name: '',
          appId:'',
          remark:'',
          game_char_id: '',
          game_account_id:0,
          user_type:1,
          type: 1,
          pay_way: '',
          price:0
        },
        alipay:'',
        tip:'请扫码支付',
        tipFlag:true,
        pay_qrcode:'',
        options:[],
        orderNo:'',
        timerNum:0,
        server_name:'',
        pay_scale:1,
        type:1,
        qq_contact:'',
        serverDetail:{},
        queryCharBtn:false,
        timer:null,
        payBtn:false,
        rules: {
          game_account_name: [
            { required: true, message: '请输入游戏账号', trigger: 'blur' },
          ],
          game_char_id: [
            { required: true, message: '请选择游戏角色', trigger: 'change' }
          ],
          price: [
            { required: true, message: '请填写金额', trigger: 'blur' }
          ],
          pay_way: [
            { required: true, message: '请选择支付方式', trigger: 'change' }
          ],
          desc: [
            { required: true, message: '请填写活动形式', trigger: 'blur' }
          ]
        }
      };
    },
    methods: {
        getCharList(){
            let self = this;
            self.queryCharBtn = true;
            self.postRequest('/game/characters_list',self.ruleForm).then(resp =>{
                 self.queryCharBtn=false;
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.options = resp.data;
                 if(self.options.length > 0){
                    self.ruleForm.game_account_id = self.options[0].game_account_id;
                 }
                 Message.success({message: '加载成功，请选择角色'});
            })

        },
      submitForm(formName) {
        let self = this;
        self.payBtn = true;
        self.$refs[formName].validate((valid) => {
          if (valid) {
            self.postRequest('/saas/plate/order/hpay',self.ruleForm).then(resp =>{
                 self.payBtn=false;
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                if(self.ruleForm.pay_way == 1){
                    //self.alipay = resp.data.sign;
                    self.pay_qrcode = resp.data.qrcode;
                    self.orderNo = resp.data.order_no;
                    self.wxPayDialogVisible=true;
                   //// self.$nextTick(()=>{
                     //   self.$refs.alipayWeb.children[0].submit();
                   // });
                }else if(self.ruleForm.pay_way == 2){
                    self.pay_qrcode = resp.data.qrcode
                    self.orderNo = resp.data.order_no;
                    self.wxPayDialogVisible=true;
                }
                self.queryOrder();

            })
          } else {
            self.payBtn=false;
            console.log('error submit!!');
            return false;
          }
        });
      },

      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      getParam(){
        let self = this;
        var url = window.location.href ;             //获取当前url
        var dz_url = url.split('#')[0];                //获取#/之前的字符串
        var csstr = dz_url.split('?')[1];                //获取?之后的参数字符串
        var cs_arr = csstr.split('&');                    //参数字符串分割为数组
        var cs={};
        for(var i=0;i<cs_arr.length;i++){         //遍历数组，拿到json对象
            cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
        }
        self.ruleForm.appId = cs.appId;                                           //这样就拿到了参数中的数据
        console.log("this.ruleForm.appId:"+self.ruleForm.appId);

        self.postRequest('/saas_user/detail',self.ruleForm).then(resp =>{
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.serverDetail = resp.data;
                 
                document.title = resp.data.app_name;
                self.server_name = resp.data.app_name;
                self.pay_scale = resp.data.pay_scale;
                self.qq_contact = resp.data.custom_qq;
            })

       

      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      queryOrder(){
        let self = this;
        self.timer = setTimeout(() => {
          //需要定时执行的代码
          console.debug("Hello World:"+self.timerNum);
          let q = {
            order_no:self.orderNo
          };
          if(self.timerNum >= 15){
            clearTimeout(self.timer);
            self.tip="支付失败，如已支付，请联系客服";
            Message.error({message: "支付失败，如已支付，请联系客服"});
            return;
          }
          self.postRequest('/order/query',q).then(resp =>{
                 self.timerNum++;
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    clearTimeout(self.timer);
                    return;
                 }
                 self.tip="查询支付结果中.....";
                 let order = resp.data;
                 if(order){
                  var payStatus = order.pay_status;
                  if(payStatus == 1){
                    self.tip="支付成功";
                    Message.success({message: "支付成功"});
                    self.tipFlag = false;
                    clearTimeout(self.timer);
                  }
      
                 }
            
            })
            self.queryOrder();
          }, 5000)
      }
    },
    created(){
        this.getParam();
    }
  }
</script>
<style scoped>
    .title-class{
        padding-left: 140px;
        padding-top: 30px;
    }
    .get-role{
        margin-left: 10px;
    }
    .content{
        margin: 0 auto;
        margin-top: 50px;
        align-content: center;
        width: 50%;
        height: 600px;
        max-height: 800px;
        background-color: rgb(161, 194, 203);
        border-radius: 20px;
    }
    .form-class{
        padding-top: 20px;
        padding-left: 90px;
        width: 60%;
    }

</style>